import { render, staticRenderFns } from "./ReceiveTransferInventory.vue?vue&type=template&id=10a23406"
import script from "./ReceiveTransferInventory.vue?vue&type=script&lang=js"
export * from "./ReceiveTransferInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports